import { IconButton, SvgIcon } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import getMuiIcon from '../../../../utils/getMuiIcon';

interface VoiceDemoButtonProps {
	fieldName: string;
	isPlaying: boolean;
	onToggle: () => void;
}

// Both icons carry their own hardcoded fill, so the button contributes only a hit target.
const buttonStyles = {
	flex: '0 0 auto',
	width: 40,
	height: 40,
};

const VoiceDemoButton: React.FC<VoiceDemoButtonProps> = ({ fieldName, isPlaying, onToggle }) => {
	const { t } = useTranslation();

	return (
		<IconButton
			onClick={onToggle}
			aria-label={isPlaying ? t('Pause') : t('Play')}
			data-testid={`voice-demo-button-${fieldName}`}
			data-playing={String(isPlaying)}
			sx={buttonStyles}
		>
			<SvgIcon component={getMuiIcon(isPlaying ? 'pauseCircle' : 'volumeBlue')} aria-hidden="true" />
		</IconButton>
	);
};

export default VoiceDemoButton;
